module.exports = __webpack_public_path__ + "img/ls.c23abb82.svg";